module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vehicle-dashboard"
  }, [_c('div', {
    staticClass: "dashboard-header d-flex justify-content-between align-items-start mb-4"
  }, [_c('div', {
    staticClass: "dashboard-header-left"
  }, [_c('h2', {
    staticClass: "text-primary font-weight-bold mb-0"
  }, [_vm._v("Vehicle Performance Dashboard")]), _vm._v(" "), (!_vm.selectedVehicleRegNo) ? _c('p', {
    staticClass: "text-muted small"
  }, [_vm._v("Advanced Fleet Analytics & Intelligence")]) : _c('div', {
    staticClass: "d-flex align-items-center mt-1"
  }, [_c('b-badge', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "px-3 py-2 mr-2 shadow-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "variant": "primary",
      "pill": "",
      "title": "View Technical Details"
    },
    on: {
      "click": function($event) {
        _vm.onOpenVehicleMasterDetails({
          vehicleTruckId: _vm.selectedVehicleId,
          regNo: _vm.selectedVehicleRegNo
        })
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr-1 text-white",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("local_shipping")]), _vm._v(" \n           Vehicle: " + _vm._s(_vm.selectedVehicleRegNo) + "\n        ")], 1), _vm._v(" "), _c('b-button', {
    staticClass: "shadow-sm",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.clearVehicleSelection
    }
  }, [_c('md-icon', {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("arrow_back")]), _vm._v(" Back to Fleet Overview\n        ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-2 stats-ticker align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ticker-item mr-4 d-flex align-items-center"
  }, [_c('span', {
    staticClass: "text-muted xs-font mr-2"
  }, [_vm._v("FLEET STATUS:")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mini-gauge-container",
    attrs: {
      "title": _vm.summaryData ? ("Active: " + (_vm.summaryData.activeVehicles) + ", Inactive: " + (_vm.summaryData.inactiveVehicles)) : 'Active: 32, Inactive: 10'
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "radialBar",
      "height": "40",
      "width": "40",
      "options": _vm.miniFleetOptions,
      "series": _vm.summaryData ? [_vm.summaryData.activePercentage] : [76]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ticker-item"
  }, [_c('span', {
    staticClass: "text-muted xs-font"
  }, [_vm._v("FLEET HEALTH:")]), _vm._v(" "), _c('span', {
    class: ['font-weight-bold', _vm.summaryData && _vm.summaryData.fleetStatus === 'WARNING' ? 'text-warning' : 'text-success']
  }, [_vm._v(_vm._s(_vm.summaryData ? _vm.summaryData.fleetStatus : 'OPTIMAL'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-controls d-flex align-items-end"
  }, [_c('b-form-group', {
    staticClass: "mb-0 mr-3 dashboard-date-group",
    attrs: {
      "label": "Date Range"
    }
  }, [_c('date-range-picker', {
    staticClass: "glass-input",
    attrs: {
      "locale-data": _vm.locale,
      "auto-apply": true
    },
    on: {
      "update": _vm.onDateRangeSelected
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "mb-0 mr-3",
    staticStyle: {
      "min-width": "250px"
    },
    attrs: {
      "label": "Vehicle Search"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllVehicleDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "input": _vm.refreshData
    },
    model: {
      value: (_vm.selectedVehicleId),
      callback: function($$v) {
        _vm.selectedVehicleId = $$v
      },
      expression: "selectedVehicleId"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "shadow-sm px-4 dashboard-refresh-btn",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('md-icon', [_vm._v("refresh")])], 1)], 1)]), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, _vm._l((_vm.filteredKpiSummary), function(kpi, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "md": "3"
      }
    }, [_c('kpi-card', _vm._b({}, 'kpi-card', kpi, false))], 1)
  })), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "shadow-sm": "",
      "id": "details-section"
    }
  }, [_c('b-tabs', {
    attrs: {
      "pills": "",
      "card": "",
      "active-nav-item-class": "bg-primary text-white shadow"
    },
    on: {
      "input": _vm.handleTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Utilization & Trips",
      "active": ""
    }
  }, [_c('utilization-tab', {
    attrs: {
      "items": _vm.filteredVehicleUtilization,
      "fields": _vm.utilizationFields,
      "chart-options": _vm.utilizationChartOptions,
      "chart-series": _vm.utilizationChartSeries,
      "view-mode": _vm.viewMode,
      "vehicle-filter": _vm.vehicleFilter,
      "top-n": _vm.utilizationTopN,
      "show-export": true,
      "is-exporting": _vm.isUtilizationExporting,
      "loading": _vm.isSummaryLoading
    },
    on: {
      "select-vehicle": _vm.selectVehicle,
      "open-trip-details": _vm.onUtilizationTripDrilldown,
      "open-assignment-details": _vm.onUtilizationAssignmentDrilldown,
      "open-master-details": _vm.onOpenVehicleMasterDetails,
      "update:viewMode": function($event) {
        _vm.viewMode = $event
      },
      "update:vehicleFilter": function($event) {
        _vm.vehicleFilter = $event
      },
      "update:topN": function($event) {
        _vm.utilizationTopN = $event
      },
      "export": _vm.exportUtilizationToExcel
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Operations Intelligence"
    }
  }, [_c('operations-intelligence-tab', {
    attrs: {
      "trip-volume-series": _vm.tripVolumeSeries,
      "trip-volume-options": _vm.tripVolumeOptions,
      "availability-series": _vm.availabilitySeries,
      "availability-options": _vm.availabilityOptions,
      "vehicle-trips-series": _vm.vehicleTripsSeries,
      "vehicle-trips-options": _vm.vehicleTripsOptions,
      "fuel-trend-series": _vm.fuelTrendSeries,
      "fuel-trend-options": _vm.fuelTrendOptions,
      "audit-stats": _vm.accountingAuditStats,
      "volume-loading": _vm.isTripVolumeLoading,
      "availability-loading": _vm.isAvailabilityLoading,
      "activity-loading": _vm.isVehicleActivityLoading,
      "audit-loading": _vm.isAccountingAuditLoading,
      "fuel-loading": _vm.isFuelEfficiencyLoading
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Location Intelligence"
    }
  }, [_c('location-intelligence-tab', {
    attrs: {
      "trip-trends-series": _vm.tripTrendsSeries,
      "trip-trends-options": _vm.tripTrendsOptions,
      "density-data": _vm.locationDensity,
      "trip-loading": _vm.isLocationTripLoading,
      "density-loading": _vm.isLocationDensityLoading,
      "initial-role": _vm.selectedLocationRole
    },
    on: {
      "role-change": _vm.onLocationRoleChanged
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Financial Analytics"
    }
  }, [_c('financial-analytics-tab', {
    attrs: {
      "client-series": _vm.clientRevenueSeries,
      "client-options": _vm.clientRevenueOptions,
      "vehicle-series": _vm.vehicleRevenueSeries,
      "vehicle-options": _vm.vehicleRevenueOptions,
      "shipping-line-series": _vm.slRevenueSeries,
      "shipping-line-options": _vm.slRevenueOptions,
      "monthly-revenue-series": _vm.monthlyRevenueSeries,
      "monthly-revenue-options": _vm.monthlyRevenueOptions,
      "yearly-revenue-series": _vm.yearlyRevenueSeries,
      "yearly-revenue-options": _vm.yearlyRevenueOptions,
      "client-raw-data": _vm.clientRevenueRaw,
      "vehicle-raw-data": _vm.vehicleRevenueRaw,
      "sl-raw-data": _vm.slRevenueRaw,
      "monthly-raw-data": _vm.monthlyRevenueRaw,
      "yearly-raw-data": _vm.yearlyRevenueRaw,
      "client-expense-series": _vm.clientExpenseSeries,
      "client-expense-options": _vm.clientExpenseOptions,
      "vehicle-expense-series": _vm.vehicleExpenseSeries,
      "vehicle-expense-options": _vm.vehicleExpenseOptions,
      "shipping-line-expense-series": _vm.slExpenseSeries,
      "shipping-line-expense-options": _vm.slExpenseOptions,
      "monthly-expense-series": _vm.monthlyExpenseSeries,
      "monthly-expense-options": _vm.monthlyExpenseOptions,
      "yearly-expense-series": _vm.yearlyExpenseSeries,
      "yearly-options": _vm.yearlyExpenseOptions,
      "client-expense-raw": _vm.clientExpenseRaw,
      "vehicle-expense-raw": _vm.vehicleExpenseRaw,
      "loading": _vm.isFinanceLoading,
      "sl-expense-raw": _vm.slExpenseRaw,
      "monthly-expense-raw": _vm.monthlyExpenseRaw,
      "yearly-expense-raw": _vm.yearlyExpenseRaw
    }
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Maintenance & Health"
    }
  }, [(_vm.activeTab === 4) ? _c('maintenance-health-tab', {
    attrs: {
      "items": _vm.maintenanceHistory,
      "item-brief": _vm.maintenanceItemBrief,
      "loading": _vm.isMaintenanceLoading,
      "brief-loading": _vm.isItemBriefLoading,
      "selected-vehicle-id": _vm.selectedVehicleId
    },
    on: {
      "select-vehicle": _vm.selectVehicle
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "title": "Revenue vs Expense Trend",
      "type": "area",
      "height": "350",
      "options": _vm.chartOptions,
      "series": _vm.filteredChartSeries
    }
  }, [
    [_c('b-form-radio-group', {
      attrs: {
        "options": ['Monthly', 'Weekly'],
        "buttons": "",
        "size": "sm",
        "variant": "outline-primary"
      },
      model: {
        value: (_vm.chartPeriod),
        callback: function($$v) {
          _vm.chartPeriod = $$v
        },
        expression: "chartPeriod"
      }
    })]
  ], 2)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('vehicle-mini-list', {
    attrs: {
      "title": "Most Used Vehicles",
      "items": _vm.topVehicles,
      "type": "most-used"
    },
    on: {
      "select-vehicle": _vm.selectVehicle,
      "open-master-details": _vm.onOpenVehicleMasterDetails,
      "view-all": _vm.scrollToDetails
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('vehicle-mini-list', {
    attrs: {
      "title": "Idle Vehicles (> 3 Days)",
      "items": _vm.idleVehicles,
      "type": "idle"
    },
    on: {
      "select-vehicle": _vm.selectVehicle,
      "open-master-details": _vm.onOpenVehicleMasterDetails,
      "view-all": _vm.onIdleVehiclesDrilldown
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "shadow-sm": ""
    }
  }, [_c('b-card-header', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-bold text-primary"
  }, [_vm._v("Fleet Status Details")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Vehicle-wise status buckets")])]), _vm._v(" "), _c('b-card-body', [_c('b-tabs', {
    attrs: {
      "pills": ""
    },
    model: {
      value: (_vm.statusTabIndex),
      callback: function($$v) {
        _vm.statusTabIndex = $$v
      },
      expression: "statusTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": ("Available (" + (_vm.availableVehicles.length) + ")")
    }
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "small": "",
      "hover": "",
      "striped": "",
      "responsive": "",
      "items": _vm.availableVehicles,
      "fields": _vm.statusVehicleFields
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(row) {
        return [_vm._v("\n                  " + _vm._s(row.index + 1) + "\n                ")]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(row.item),
            "pill": ""
          }
        }, [_vm._v("\n                    " + _vm._s(row.item.status || "N/A") + "\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": ("Booked (" + (_vm.bookedVehicles.length) + ")")
    }
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "small": "",
      "hover": "",
      "striped": "",
      "responsive": "",
      "items": _vm.bookedVehicles,
      "fields": _vm.statusVehicleFields
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(row) {
        return [_vm._v("\n                  " + _vm._s(row.index + 1) + "\n                ")]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(row.item),
            "pill": ""
          }
        }, [_vm._v("\n                    " + _vm._s(row.item.status || "N/A") + "\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": ("Unknown (" + (_vm.unknownVehicles.length) + ")")
    }
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "small": "",
      "hover": "",
      "striped": "",
      "responsive": "",
      "items": _vm.unknownVehicles,
      "fields": _vm.statusVehicleFields
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(row) {
        return [_vm._v("\n                  " + _vm._s(row.index + 1) + "\n                ")]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(row.item),
            "pill": ""
          }
        }, [_vm._v("\n                    " + _vm._s(row.item.status || "N/A") + "\n                  ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": ("Inactive (" + (_vm.inactiveVehicles.length) + ")")
    }
  }, [_c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "small": "",
      "hover": "",
      "striped": "",
      "responsive": "",
      "items": _vm.inactiveVehicles,
      "fields": _vm.statusVehicleFields
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(row) {
        return [_vm._v("\n                  " + _vm._s(row.index + 1) + "\n                ")]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(row.item),
            "pill": ""
          }
        }, [_vm._v("\n                    " + _vm._s(row.item.status || "N/A") + "\n                  ")])]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "title": "Expense Breakdown",
      "type": "donut",
      "height": "320",
      "options": _vm.expenseCategoryOptions,
      "series": _vm.expenseCategorySeries,
      "loading": _vm.isExpenseCategoryLoading,
      "footer": "Categorized by transit and logistics ledger groups"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('dashboard-chart', {
    attrs: {
      "title": "Fleet Status",
      "type": "donut",
      "height": "320",
      "options": _vm.fleetStatusDonutOptions,
      "series": _vm.fleetStatusDonutSeries,
      "loading": _vm.isFleetStatusLoading,
      "footer": _vm.fleetStatusFooter
    }
  })], 1)], 1), _vm._v(" "), _c('vehicle-utilization-drilldown-modal', {
    attrs: {
      "visible": _vm.utilDrillModalVisible,
      "title": _vm.utilDrillModalTitle,
      "fields": _vm.utilDrillModalFields,
      "items": _vm.utilDrillModalItems,
      "loading": _vm.utilDrillModalLoading,
      "error-message": _vm.utilDrillModalError,
      "show-export": true,
      "is-exporting": _vm.isDrilldownExporting,
      "total": _vm.utilDrillModalTotal,
      "page": _vm.utilDrillModalPage,
      "page-size": _vm.utilDrillModalPageSize
    },
    on: {
      "update:visible": function($event) {
        _vm.utilDrillModalVisible = $event
      },
      "page-change": _vm.onDrilldownPageChange,
      "export": _vm.onDrilldownExport
    }
  }), _vm._v(" "), _c('vehicle-master-details-modal', {
    attrs: {
      "visible": _vm.vehicleMasterModalVisible,
      "vehicle-truck-id": _vm.masterVehicleId,
      "vehicle-no": _vm.masterVehicleNo
    },
    on: {
      "update:visible": function($event) {
        _vm.vehicleMasterModalVisible = $event
      }
    }
  }), _vm._v(" "), _c('service-estimation-modal', {
    attrs: {
      "visible": _vm.showServiceModal,
      "service": _vm.selectedService,
      "spare-parts": _vm.spareParts
    },
    on: {
      "update:visible": function($event) {
        _vm.showServiceModal = $event
      },
      "download-estimate": _vm.downloadEstimate,
      "go-to-maintenance": _vm.goToMaintenanceModule
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticker-item mr-4"
  }, [_c('span', {
    staticClass: "text-muted xs-font"
  }, [_vm._v("LIVE DRIVERS:")]), _vm._v(" "), _c('span', {
    staticClass: "text-primary font-weight-bold"
  }, [_vm._v("38/42")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f55c1ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/VehiclePerformanceDash.vue
// module id = 2783
// module chunks = 0